import type { Market } from '@client/modules/app-context/constants';
import { saveRating } from '@client/modules/rating/api';
import type { FeedbackType, RatingRequest } from '@client/modules/rating/model';
import { RatingType } from '@client/modules/rating/model';

export function ratedCancellationRequestEvent(
  ratingNumber: number,
  feedbackType: FeedbackType,
  category: string,
  market: Market,
  cancellationId?: string,
  ratingText?: string
) {
  const ratingRequest: RatingRequest = {
    rating: ratingNumber,
    maxRating: 5,
    value: ratingText,
    ratingType: RatingType.CancellationRating,
    ratingTypeUUID: cancellationId,
    feedbackType: feedbackType,
    market: market,
    categoryName: { name: category },
  };
  saveRating(ratingRequest);
}
